import { useEffect, useRef, useState } from "react";

// Small "?" contextual help bubble. Click to toggle; closes on outside click.
export const HelpTip = ({ text, testId }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onDoc = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, [open]);

  return (
    <span className="relative inline-flex align-middle" ref={ref}>
      <button
        type="button"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setOpen((v) => !v);
        }}
        className={`w-4 h-4 rounded-full text-[10px] font-black leading-none flex items-center justify-center border transition-colors ${
          open
            ? "bg-[#0A1C40] text-[#FFC220] border-[#0A1C40]"
            : "bg-white text-[#0A1C40] border-[#0A1C40]/50 hover:border-[#0A1C40]"
        }`}
        aria-label="Help"
        data-testid={testId || "help-tip"}
      >
        ?
      </button>
      {open && (
        <span
          className="absolute z-50 left-1/2 -translate-x-1/2 top-6 w-64 bg-[#0A1C40] text-white text-xs leading-relaxed p-3 rounded shadow-xl normal-case font-normal tracking-normal"
          data-testid={testId ? `${testId}-popover` : "help-tip-popover"}
        >
          {text}
        </span>
      )}
    </span>
  );
};
